/**
 * Created by virus_zhh on 2017/9/3.
 */
import $ from 'jquery'
import Cookies from 'js-cookie'
import {
  ajax,
  axios,
  common
} from '@/untils'

const permission = {
  namespaced: true,
  state: {
    user: {
      id: 1,
      username: 'mark',
      name: '小张',
      avatar: '/static/img/layouts/layout/avatar4.jpg',
      forUpdate: {
        userID: 1,
        userName: '小张',
        userMobile: '135666666',
        userType: 1,
        chiefNurseID: 1,
        chiefNurseName: '李护士长',
      }
    },
    token: ''
  },
  mutations: {
    SET_USER_INFO: (state, info) => {
      info.avatar = '/static/img/layouts/layout/avatar4.jpg'

      state.user = info
      //   Cookies.set('current_user', JSON.stringify(info))
      localStorage.setItem("ivms_current_user", JSON.stringify(info));
    },
    RESET_USER_INFO: (state) => {
        localStorage.removeItem("ivms_current_user")
        state.user = {}
    },
  },
  actions: {
    login({
      commit
    }, userInfo) {
      return $.Deferred(function (defer) {
        axios.post("login", userInfo).then(rst => {
          if (rst.retCode === 0) {
            commit('SET_USER_INFO', rst.retData)
            defer.resolve(rst.retData)
          } else {
            defer.reject({
              message: rst.retMsg
            })
          }
        });
      }).promise()
    },
    checkLogin({
      commit
    }, userInfo) {

      return $.Deferred(function (defer) {
        // let defautlUser = {
        //   id: 1,
        //   username: 'mark',
        //   name: '小张',
        //   avatar: '/static/img/layouts/layout/avatar4.jpg',
        //   forUpdate: {
        //     userID: 1,
        //     userName: '小张',
        //     userMobile: '135666666',
        //     userType: 1,
        //     managerID: 1,
        //     managerName: '护士长'
        //   }
        // }
        let user = localStorage.getItem("ivms_current_user");

        if (user) {
          commit('SET_USER_INFO', JSON.parse(user))
          defer.resolve()
        } else {
          defer.reject()
        }
      }).promise()
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js